import { useParams } from "react-router-dom";
import { ProjectPage } from "@/components/Projects/ProjectPage";

export function ProjectRoute() {
  const { id } = useParams<{ id: string }>();
  if (!id) return null;
  return <ProjectPage projectId={id} />;
}
